import moment from "moment";
import { useEffect, useRef, useState } from "react";
import submit from "submit-form";
import { usePrevious } from "../usePrevious";

export const usePhaseSelection = (
  phasesAttachments,
  setPhasesAttachment,
  athlete,
  reloading,
  setReloading,
  organizationCoachId = undefined,
  track = "training"
) => {
  // Flag used to refresh the UI when sending the request to de db. See the useEffect in this file
  const [stateChangeFlag, setStateChangeFlag] = useState({
    changed: false,
    flag: false,
  });

  const prevPhasesAttachments = usePrevious(phasesAttachments);
  // Ref used to keep the reference to the same timeout instead of creating new ones every time
  const ref = useRef();

  const handlePhaseSelection = (
    phaseName,
    dateAttachment,
    weekFirstDay,
    isSelected
  ) => {
    if (reloading) return;

    const weekLastDay = moment(weekFirstDay).add(6, "days");

    //   First remove the phase selected in the same week (if existing)
    const currentPhases = phasesAttachments.filter((phase) => {
      return !moment(phase.dateAttachment, "YYYYMMDD").isBetween(
        moment(weekFirstDay).startOf("day"),
        moment(weekLastDay).endOf("day"),
        undefined,
        "[]"
      );
    });

    // Then add the selected one (if any was selected)
    !isSelected && currentPhases.push({ phaseName, dateAttachment });

    // Store the current information in the state, and change the flag
    setPhasesAttachment(currentPhases);
    setStateChangeFlag({ changed: true, flag: !stateChangeFlag.flag });
  };

  // Just handling the checkboxes submission
  const handleSubmitCheckbox = () => {
    setReloading(true);
    let body =
      // If we are removing the phases, and we send the [] as array, it is parsed to undefined
      // So we pass it as a string and handle it in the api
      {
        phasesAttachments: phasesAttachments.length ? phasesAttachments : "[]",
        athleteId: athlete._id,
        track,
      };
    if (organizationCoachId) {
      body = { ...body, organizationCoachId };
    }
    submit("/actions/annual-planner/set-athlete-phase-attachment", {
      method: "POST",
      body,
    });
  };

  // This useEffect works as our debounce tool. It submits the checkboxes data
  useEffect(() => {
    if (
      (prevPhasesAttachments === phasesAttachments &&
        !phasesAttachments.length) ||
      !stateChangeFlag.changed
    )
      return;
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      handleSubmitCheckbox();
    }, 2750);
  }, [stateChangeFlag]);

  useEffect(() => {
    setReloading(false);
  }, []);

  return {
    handlePhaseSelection,
  };
};
